import React from 'react';
import { Skeleton } from 'boneyard-js/react';

const LoadingDNA: React.FC = () => {
  return (
    <Skeleton
      name="page-loading-shell"
      loading={true}
      animate="shimmer"
      fallback={
        <div className="w-full rounded-[16px] border border-[#d9e8f0] bg-[#f5fbff] p-4">
          <div className="h-6 w-52 rounded-md bg-[#d5e6ef]" />
          <div className="mt-2 h-4 w-80 max-w-full rounded-md bg-[#e0edf4]" />
          <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={`loading-card-${index}`}
                className="rounded-[14px] border border-[#e3eef5] bg-white p-3"
              >
                <div className="h-4 w-28 rounded bg-[#dbe8f0]" />
                <div className="mt-2 h-7 w-20 rounded bg-[#cfe2ed]" />
                <div className="mt-3 h-3 w-full rounded bg-[#e6f0f6]" />
                <div className="mt-2 h-3 w-2/3 rounded bg-[#e6f0f6]" />
              </div>
            ))}
          </div>
          <div className="mt-4 rounded-[14px] border border-[#e3eef5] bg-white p-3">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={`loading-row-${index}`} className="mt-2 h-4 w-full rounded bg-[#e4eef5]" />
            ))}
          </div>
        </div>
      }
    >
      <div className="min-h-[45vh]" />
    </Skeleton>
  );
};

export default LoadingDNA;
